import { render, staticRenderFns } from "./practice-zicai.vue?vue&type=template&id=13c098ba&scoped=true&"
import script from "./practice-zicai.vue?vue&type=script&lang=ts&"
export * from "./practice-zicai.vue?vue&type=script&lang=ts&"
import style0 from "./practice-zicai.vue?vue&type=style&index=0&id=13c098ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c098ba",
  null
  
)

export default component.exports